import React from "react";
import PropTypes from "prop-types";
import UpgradeForm from "components/payments/UpgradeForm";
import UpgradePrice from "components/payments/UpgradePrice";
import { fetchUpgradePrice } from "components/payments/hooks";

export default function AnnualUpgradeModalForm(props) {
  const {
    defaultErrorMessage,
    lastPaidWithStripe,
    paypalEnvironment,
    planCode,
    planCost,
    planDuration,
    planId,
    renewalDate,
    upgradePricePath
  } = props;

  // I'm pulling these off separately because they are only used in test.
  // If they're undefined, the real elements will be used, but if components
  // are passed in, we can render a slightly different version of this component
  // to use in Capybara tests without actually talking to either Stripe or Paypal.
  const { PaypalButton, StripePaymentElement } = props;

  const upgradePrice = fetchUpgradePrice(props.upgradePrice, upgradePricePath);

  return (
    <div data-test-id="">
      <p className="user-subscribe-sell__section">
        Upgrade today and you will be charged{" "}
        <strong>
          $<UpgradePrice upgradePrice={upgradePrice} />
        </strong>
        , which is the {planCost} {planDuration} subscription fee, minus a
        credit for the monthly charge you already paid for the remainder of this
        month.
      </p>
      <p className="user-subscribe-sell__section">
        Your new annual subscription will start today and renew on {renewalDate}{" "}
        unless you cancel first. You can cancel anytime via your Account
        Settings page.
      </p>
      <UpgradeForm
        defaultErrorMessage={defaultErrorMessage}
        FormButtons={FormButtons}
        lastPaidWithStripe={lastPaidWithStripe}
        PaypalButton={PaypalButton}
        paypalEnvironment={paypalEnvironment}
        planCode={planCode}
        planId={planId}
        StripePaymentElement={StripePaymentElement}
        upgradePrice={upgradePrice}
      />
    </div>
  );
}

AnnualUpgradeModalForm.propTypes = {
  PaypalButton: PropTypes.element,
  StripePaymentElement: PropTypes.element,
  lastPaidWithStripe: PropTypes.bool.isRequired,
  paypalEnvironment: PropTypes.string.isRequired,
  planCode: PropTypes.string.isRequired,
  planCost: PropTypes.string.isRequired,
  planDuration: PropTypes.string.isRequired,
  planId: PropTypes.string.isRequired,
  renewalDate: PropTypes.string.isRequired,
  upgradePrice: PropTypes.shape({
    errorMessage: PropTypes.string,
    price: PropTypes.string,
    prorationDate: PropTypes.string
  }).isRequired,
  upgradePricePath: PropTypes.string.isRequired
};

const FormButtons = ({ disabled, processing }) => (
  <div className="user-subscribe-sell__upgrade-subscription ">
    <button
      className="btn btn-primary btn-lg form-button form-submit js-upgrade-button"
      disabled={disabled || processing}
      type="submit"
    >
      {processing ? (
        <span>
          <i className="fa fa-cog fa-spin fa-fw" />
          Upgrading
        </span>
      ) : (
        "Upgrade Subscription"
      )}
    </button>
  </div>
);
